
import WDCard from './wd-card';
import WDForm from '../form/wd-form';

export default class WDCardForm extends WDCard {

  #options = {};
  #form = null;

  constructor(opts)
  {
    super(opts).classList.add('wd-card-form');

    if (opts) Object.assign(this.#options,opts);
  };
    
  //
  get form() { 

    if (!this.#form)
    {
      this.#form = new WDForm(this.#options);
      this.body.append(this.#form);
    }

    return this.#form; 
  };

  get model() { return this.#form.model; };
  get items() { return this.form.items; };

  get dirty() { return this.form.dirty; };
  set dirty(val) { this.form.dirty = val; };

  get value() { return this.form.value; };
  set value(val) { return this.form.value = val; };
 
  get readonly() { return this.form.readonly; };
  set readonly(val) { return this.form.readonly = val; };

  //form method shortcuts
  addForms(data) { return this.form.addForms(data); };
	addForm(data) { return this.form.addForm(data); };
  getItem(itemName) { return this.form.getItem(itemName); };
	validate(data) { return this.form.validate(data); };	
	
	//
	reset()
	{
	  this.resetNavbar();
	  this.resetToolbar();

    this.#form.remove();
    this.#form = new WDForm(this.#options);
    this.body.append(this.#form);

    this.setup();
	};

  req() { return this.model.req(); };
  post() { return this.model.post(); };
  del() { return this.model.del(); };

};

customElements.define('wd-card-form',WDCardForm);
